import ProcessingPayment from './ProcessingPayment';

export default ProcessingPayment;
